export const en = {
  app: {
  }
};
